import React from 'react';
import type { ComponentProps, ReactElement } from 'react';

import type { ListItem as OriginalListItem } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';

export const ListItem = ({
	children,
	lightNodeRef,
}: ComponentProps<typeof OriginalListItem> & LightNodeProps): ReactElement => (
	<li ref={lightNodeRef}>{children}</li>
);
